import { Injectable } from '@angular/core';
import { connectFunctionsEmulator, getFunctions, httpsCallable } from '@angular/fire/functions';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  private functions= getFunctions()

 

  sendInviteEmail(email: string, inviteUrl: string, isEmulator: boolean) {
    if (isEmulator) {
      console.log('Emulator mode enabled');
      connectFunctionsEmulator(this.functions, 'localhost', 7004);
    }
    const sendEmailFn = httpsCallable(this.functions, 'users-sendInviteEmail');
    return sendEmailFn({ email, inviteUrl });
  }

  async sendEmailOtpFunction(email: string, isEmulator: boolean = false): Promise<{ success: boolean; message: string }> {

    try {
      if (isEmulator) {
        console.log('Emulator mode enabled');
        connectFunctionsEmulator(this.functions, 'localhost', 7004);
      }
      const sendOtpCallable = httpsCallable(this.functions, 'users-sendEmailOtp');
      const response = await sendOtpCallable({ email });
      return { success: true, message: response?.data as string };

    } catch (error) {
      return { success: false, message: "Failed to send OTP." };
    }
  }
}